import ThirdPartyEmailPassword, { Google } from 'supertokens-auth-react/recipe/thirdpartyemailpassword';
import { ThirdPartyEmailPasswordPreBuiltUI } from 'supertokens-auth-react/recipe/thirdpartyemailpassword/prebuiltui';
import Session from 'supertokens-auth-react/recipe/session';
import EmailVerification from 'supertokens-auth-react/recipe/emailverification';
import { EmailVerificationPreBuiltUI } from 'supertokens-auth-react/recipe/emailverification/prebuiltui';
import { extractDomain } from '@appblocks/utils';

export const SuperTokensConfig = {
    appInfo: {
        appName: 'AppBlocks',
        apiDomain: process.env.API_URL,
        websiteDomain: process.env.APP_URL,
    },
    // recipeList contains all the modules that you want to
    // use from SuperTokens. See the full list here: https://supertokens.com/docs/guides
    recipeList: [
        EmailVerification.init({
            mode: 'OPTIONAL',
        }),
        ThirdPartyEmailPassword.init({
            getRedirectionURL: async (context) => {
                if (context.action === 'SUCCESS') {
                    const queryString = window.location.search;
                    const urlParams = new URLSearchParams(queryString);
                    const redirect = urlParams.get('redirect');
                    if (redirect !== null) {
                        return redirect;
                    }
                    return '/';
                }
                return undefined;
            },
            onHandleEvent: async (context) => {
                if (context.action === 'SUCCESS') {
                    window.location.href = '/';
                }
            },
            style: `
                [data-supertokens~="container"] {
                    --palette-primary: 13, 110, 253;
                    --palette-primaryBorder: 13, 110, 253;
                }

                [data-supertokens="superTokensBranding"] {
                    display: none;
                }
            `,
            signInAndUpFeature: {
                disableDefaultUI: true,
                providers: [Google.init()],
                signUpForm: {
                    formFields: [
                        {
                            id: 'first_name',
                            label: 'First Name',
                            placeholder: 'First Name',
                            optional: true,
                        },
                        {
                            id: 'last_name',
                            label: 'Last Name',
                            placeholder: 'Last Name',
                            optional: true,
                        },
                    ],
                    termsOfServiceLink: `${process.env.HOME_URL}/terms`,
                    privacyPolicyLink: `${process.env.HOME_URL}/terms`,
                },
            },
        }),
        Session.init({
            tokenTransferMethod: extractDomain(process.env.API_URL as string) !== extractDomain(process.env.APP_URL as string) ? 'header' : 'cookie',
        }),
    ],
};

export const recipeDetails = {
    docsLink: 'https://supertokens.com/docs/thirdpartyemailpassword/introduction',
};

export const PreBuiltUIList = [ThirdPartyEmailPasswordPreBuiltUI, EmailVerificationPreBuiltUI];
